function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "instagram_svg__cls-1",
  d: "M16 4.7a5.82 5.82 0 00-.38-1.94 3.91 3.91 0 00-.92-1.42 4 4 0 00-1.46-.92A6.12 6.12 0 0011.3.05C10.45 0 10.17 0 8 0S5.56 0 4.7.05a5.61 5.61 0 00-1.94.37 3.91 3.91 0 00-1.42.92 4 4 0 00-.92 1.42A6.12 6.12 0 00.05 4.7C0 5.56 0 5.83 0 8s0 2.45.05 3.3a5.61 5.61 0 00.37 1.94 4 4 0 00.92 1.42 3.91 3.91 0 001.42.92A5.61 5.61 0 004.7 16H8c2.17 0 2.44 0 3.3-.05a5.61 5.61 0 001.94-.37 4.09 4.09 0 002.34-2.34A6.12 6.12 0 0016 11.3c0-.85.05-1.13.05-3.3S16 5.56 16 4.7zm-1.44 6.54a4.44 4.44 0 01-.28 1.48 2.65 2.65 0 01-1.52 1.52 4.51 4.51 0 01-1.48.28H4.81a4.44 4.44 0 01-1.48-.28 2.45 2.45 0 01-.92-.6 2.45 2.45 0 01-.6-.92 4.26 4.26 0 01-.27-1.48c0-.84-.05-1.1-.05-3.23s0-2.39.05-3.23a4.28 4.28 0 01.27-1.49 2.45 2.45 0 01.6-.92 2.42 2.42 0 01.92-.59 4.27 4.27 0 011.45-.28c.84 0 1.09-.05 3.23-.05s2.39 0 3.23.05a4.2 4.2 0 011.48.28 2.35 2.35 0 01.92.59 2.45 2.45 0 01.6.92 4.52 4.52 0 01.28 1.49v3.23c0 2.14.03 2.38 0 3.23z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "instagram_svg__cls-1",
  d: "M8 3.89A4.11 4.11 0 1012.11 8 4.11 4.11 0 008 3.89zm0 6.78A2.67 2.67 0 1110.67 8 2.67 2.67 0 018 10.67zm5.23-6.94a1 1 0 11-1-1 1 1 0 011 1z"
});

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}

export default SvgInstagram;